export enum EChatUserType {
  User = 'user',
  Support = 'support',
}
